import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'xy_coords',
    dependencies: [
        'levels_maths/x_coord',
        'levels_maths/y_coord'
    ]
})


function common (q, params) {
    let a = {
        x: params.x,
        y: params.y,
        name: 'A'
    }

    let geoScreen = q.addGeoScreen()
    geoScreen.addPoint(a)


    if (params.showUselessB) {
        let b = {
            x: a.x + random.fairChoiceInt(1, 3, {name: 'bx'}),
            y: a.y + random.fairChoiceInt(1, 3, {name: 'by'}),
            name:  'B',
            color: '#226ea5'
        }
        geoScreen.addPoint(b)

        q.addText(mathText.point(b))
    }



    q.addText(mathText.pointName(a) + '( ? )')
    q.answer = a.x + ';' + a.y
}


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(1, 6, {name: 'x'}),
            y: random.fairChoiceInt(1, 6, {name: 'y'}),
            showUselessB: true
        })
    },
    errorExpected: true
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(-5, -1, {name: 'x'}), // A never on O, which would hide it
            y: random.fairChoiceInt(0, 4,  {name: 'y'})
        })
    }
})


export default level

